document.addEventListener('DOMContentLoaded', function () {
  var nav = document.getElementById('nav');
  if (!nav) return;

  var mq = window.matchMedia('(max-width: 62.5em)');
  var panel = null;
  var extraRatingHidden = false;
  var layoutFixed = false;

  var i18n = {
    'www.fidello.nl': {
      loginCta: 'Inloggen of account aanmaken',
      accountCta: 'Mijn account',
      delivery: 'Voor 17:30 besteld = morgen in huis.',
      discount: 'Log in en ontvang 5% korting op het hele assortiment.',
      rating: 'lees onze klantbeoordelingen'
    },
    'www.fidello.be': {
      loginCta: 'Inloggen of account aanmaken',
      accountCta: 'Mijn account',
      delivery: 'Vandaag besteld = binnen 2 dagen in huis.',
      discount: 'Log in en ontvang 5% korting op het hele assortiment.',
      rating: 'lees onze klantbeoordelingen'
    },
    'www.fidello.de': {
      loginCta: 'Anmelden oder Konto erstellen',
      accountCta: 'Mein Konto',
      delivery: 'Heute bestellt = Lieferung in 2–3 Werktagen.',
      discount: 'Melden Sie sich an und erhalten Sie 5% Rabatt auf das gesamte Sortiment.',
      rating: 'Lesen Sie unsere Kundenbewertungen'
    },
    'www.fidello.at': {
      loginCta: 'Anmelden oder Konto erstellen',
      accountCta: 'Mein Konto',
      delivery: 'Heute bestellt = Lieferung in 2–4 Werktagen.',
      discount: 'Melden Sie sich an und erhalten Sie 5% Rabatt auf das gesamte Sortiment.',
      rating: 'Lesen Sie unsere Kundenbewertungen'
    },
    'www.fidello.lu': {
      loginCta: 'Anmelden oder Konto erstellen',
      accountCta: 'Mein Konto',
      delivery: 'Heute bestellt = Lieferung in 2–3 Werktagen.',
      discount: 'Melden Sie sich an und erhalten Sie 5% Rabatt auf das gesamte Sortiment.',
      rating: 'Lesen Sie unsere Kundenbewertungen'
    },
    'www.fidello.pl': {
      loginCta: 'Zaloguj się lub załóż konto',
      accountCta: 'Moje konto',
      delivery: 'Zamówione dzisiaj = dostawa w 1–3 dni robocze.',
      discount: 'Zaloguj się i otrzymaj 5% rabatu na cały asortyment.',
      rating: 'przeczytaj opinie naszych klientów'
    },
    'www.fidello.dk': {
      loginCta: 'Log ind eller opret konto',
      accountCta: 'Min konto',
      delivery: 'Bestilt i dag = levering på 2–3 hverdage.',
      discount: 'Log ind og få 5% rabat på hele sortimentet.',
      rating: 'læs vores kundeanmeldelser'
    },
    'www.fidello.fi': {
      loginCta: 'Kirjaudu sisään tai luo tili',
      accountCta: 'Oma tili',
      delivery: 'Tilattu tänään = toimitus 2–3 arkipäivässä.',
      discount: 'Kirjaudu sisään ja saat 5% alennuksen koko valikoimasta.',
      rating: 'lue asiakasarvostelumme'
    },
    'www.fidellofrance.fr': {
      loginCta: 'Se connecter ou créer un compte',
      accountCta: 'Mon compte',
      delivery: 'Commandé aujourd\'hui = livraison en 2 à 4 jours ouvrables.',
      discount: 'Connectez-vous et bénéficiez de 5% de réduction sur tout l\'assortiment.',
      rating: 'lisez nos avis clients'
    },
    'www.fidello.pt': {
      loginCta: 'Iniciar sessão ou criar conta',
      accountCta: 'A minha conta',
      delivery: 'Encomendado hoje = entrega em 3–4 dias úteis.',
      discount: 'Inicie sessão e receba 5% de desconto em todo o sortido.',
      rating: 'leia as nossas avaliações de clientes'
    },
    'www.fidello.se': {
      loginCta: 'Logga in eller skapa konto',
      accountCta: 'Mitt konto',
      delivery: 'Beställt idag = leverans inom 3–4 arbetsdagar.',
      discount: 'Logga in och få 5% rabatt på hela sortimentet.',
      rating: 'läs våra kundrecensioner'
    },
    'www.fidello.co.uk': {
      loginCta: 'Log in or create an account',
      accountCta: 'My account',
      delivery: null,
      discount: 'Log in and get 5% off the entire range.',
      rating: 'read our customer reviews'
    },
    'www.fidello.us': {
      loginCta: 'Log in or create an account',
      accountCta: 'My account',
      delivery: null,
      discount: 'Log in and get 5% off the entire range.',
      rating: 'read our customer reviews'
    }
  };

  function getContent() {
    var host = document.body.getAttribute('data-host') || window.location.hostname;
    return i18n[host] || i18n['www.fidello.nl'];
  }

  function buildPanel() {
    var isLoggedIn = document.body.getAttribute('data-customer-logged-in') === 'true';
    var accountHref = document.body.getAttribute('data-account-url') || '/account';
    var loginHref = document.body.getAttribute('data-login-url') || '/account/login';
    var t = getContent();

    var uspHtml = '';
    if (t.delivery || t.discount) {
      var deliveryHtml = t.delivery ? '<strong>' + t.delivery + '</strong> ' : '';
      var discountHtml = t.discount || '';
      uspHtml = '<div class="fidello-panel__usp">' + deliveryHtml + discountHtml + '</div>';
    }

    var el = document.createElement('div');
    el.className = 'fidello-panel';
    el.innerHTML =
      '<a class="fidello-panel__account" href="' + (isLoggedIn ? accountHref : loginHref) + '">' +
        '<i aria-hidden="true" class="icon-user"></i>' +
        '<span>' + (isLoggedIn ? t.accountCta : t.loginCta) + '</span>' +
      '</a>' +
      uspHtml +
      '<a class="fidello-panel__rating" href="https://judge.me/reviews/stores/fidello">' +
        '<span class="stars">★★★★☆</span> 4.7/5 – ' + t.rating +
      '</a>' +
      '<div class="fidello-panel__photo"><img src="https://cdn.shopify.com/s/files/1/0870/4186/8111/files/foto_mobile_2_fidello.png?v=1787646747" alt="Fidello huisdieren"></div>';
    return el;
  }

  function hideExtraRating() {
    if (extraRatingHidden) return;
    var links = nav.querySelectorAll('a[href="https://judge.me/reviews/stores/fidello"]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (a.classList.contains('fidello-panel__rating')) continue;
      var li = a.closest('li');
      (li || a).classList.add('fidello-hide-mobile');
    }
    extraRatingHidden = true;
  }

  function fixVoordeelLayout() {
    if (layoutFixed) return;
    var mainList = nav.querySelector('ul[data-type="main-nav"]');
    if (!mainList) return;
    var link = mainList.querySelector(':scope > li > a[href="/collections/voordeelpakketten"]');
    if (link) {
      link.closest('li').classList.add('fidello-fullwidth-row');
    }
    layoutFixed = true;
  }

  function sync(e) {
    var isMobile = e ? e.matches : mq.matches;
    if (isMobile) {
      if (!panel) {
        panel = buildPanel();
        var titleEl = nav.querySelector('.header');
        if (titleEl && titleEl.parentElement === nav) {
          titleEl.insertAdjacentElement('afterend', panel);
        } else {
          nav.insertBefore(panel, nav.firstChild);
        }
      }
      hideExtraRating();
      fixVoordeelLayout();
    } else if (panel) {
      panel.remove();
      panel = null;
    }
  }

  sync();
  if (mq.addEventListener) {
    mq.addEventListener('change', sync);
  } else if (mq.addListener) {
    mq.addListener(sync);
  }
});
